import React from 'react';

// One section of a long form: what the section is for on the left, the fields
// on the right (FECOA-2174). Stacks on small screens.
const FormSection = ({ title, description, children, className = '' }) => (
  <section className={`grid gap-4 py-7 first:pt-0 md:grid-cols-[200px_minmax(0,1fr)] md:gap-8 ${className}`}>
    <div>
      <h3 className="text-sm font-semibold text-gray-900 dark:text-gray-50">{title}</h3>
      {description && <p className="mt-1 text-[12.5px] leading-relaxed text-gray-500 dark:text-gray-400">{description}</p>}
    </div>
    <div className="min-w-0">{children}</div>
  </section>
);

export default FormSection;
